const ZERO_DECIMALS = ['VND', 'JPY', 'KRW', 'IDR', 'CLP', 'ISK', 'HUF', 'TWD', 'UGX', 'PYG'];

/**
 * Định dạng số tiền theo mã tiền của bản ghi (mặc định USD). Mã lạ → "MÃ số".
 * Dùng chung cho mọi trang admin thay các helper `toLocaleString(...)` / `$` rải rác.
 */
export function formatMoney(value, currency, locale) {
    const code = String(currency || 'USD').trim().toUpperCase() || 'USD';
    const n = Number(value);
    if (value === null || value === undefined || value === '' || Number.isNaN(n)) return '';
    const dec = ZERO_DECIMALS.includes(code) ? 0 : 2;
    try {
        return new Intl.NumberFormat(locale || 'en-US', {
            style: 'currency',
            currency: code,
            minimumFractionDigits: Number.isInteger(n) ? 0 : Math.min(2, dec),
            maximumFractionDigits: dec
        }).format(n);
    } catch (e) {
        return `${code} ${n}`;
    }
}
